// @ts-strict-ignore
import React, { ForwardedRef, forwardRef, memo } from 'react'
import FormControl from '@mui/material/FormControl'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormLabel from '@mui/material/FormLabel'
import Radio from '@mui/material/Radio'
import ServerError from 'components/ServerError'
import { FormValueInput, FormValueMeta } from 'types'
import { makeStyles } from 'tss-react/mui'

export interface IRadioButtonOption {
  value: string | boolean
  label: string
}

export interface IRadioButtonsProps {
  disabled?: boolean
  options: IRadioButtonOption[] | ReadonlyArray<IRadioButtonOption>
  input?: FormValueInput<string>
  meta?: FormValueMeta
  label?: string
}

const useStyles = makeStyles()(theme => ({
  option: {
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}))

const RadioButtons = ({
  disabled,
  options,
  label,
  input,
  meta: { touched, error } = {},
}: IRadioButtonsProps, ref: ForwardedRef<HTMLInputElement>) => {
  const { classes } = useStyles()

  return (
    <div>
      <ServerError error={touched && error} data-cy={`radio-error-${input?.name}`} />

      <FormControl>
        {label && (
          <FormLabel component="legend">
            {label}
          </FormLabel>
        )}

        <RadioGroup
          name={input?.name}
          onChange={(_, _value: any) => {
            if (typeof input?.value === 'boolean' && typeof _value === 'string') {
              // boolean support, see https://github.com/erikras/redux-form-material-ui/issues/72
              _value = (_value === 'true')
            }

            if (input?.onChange) input?.onChange(_value)
          }}
          value={typeof input?.value === 'boolean' ? (input?.value ? 'true' : 'false') : input?.value}
          style={{ display: 'flex', flexDirection: 'row' }}
          ref={ref}
        >
          {options.map((option, index) => (
            <FormControlLabel
              className={classes.option}
              key={option.value}
              value={typeof option.value === 'boolean' ? (option.value ? 'true' : 'false') : option.value}
              label={option.label}
              disabled={disabled}
              control={<Radio data-cy={`radio-${input?.name}-${index}`} color="primary" className={`cy-radio-${input?.name}-${index}`} />}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  )
}

export default memo(forwardRef(RadioButtons))
